import { render, staticRenderFns } from "./PFSettlementPendingApprovalList.vue?vue&type=template&id=0d748dda"
import script from "./PFSettlementPendingApprovalList.vue?vue&type=script&lang=js"
export * from "./PFSettlementPendingApprovalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports